import { render, staticRenderFns } from "./moyouPic.vue?vue&type=template&id=c565dc3e&scoped=true&"
import script from "./moyouPic.ts?vue&type=script&lang=js&"
export * from "./moyouPic.ts?vue&type=script&lang=js&"
import style0 from "./moyouPic.less?vue&type=style&index=0&id=c565dc3e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c565dc3e",
  null
  
)

export default component.exports